import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownAZ } from '@fortawesome/pro-light-svg-icons/faArrowDownAZ';
import { faLayerGroup } from '@fortawesome/pro-light-svg-icons/faLayerGroup';
import { Button } from 'Button';
import { Tooltip } from 'Tooltip';
import { type DisplayMode } from '../BrowseCourses.types';
import { toggleButtonProps } from '../constants';
import '../locales/browseCourses/browseCourses-en.json';

type Props = {
    displayMode: DisplayMode;
    onChange: (mode: DisplayMode) => void;
};

const MODES = [
    { mode: 'flat', icon: faArrowDownAZ, labelKey: 'flatList' },
    { mode: 'topic', icon: faLayerGroup, labelKey: 'groupedByTopic' },
] as const;

export const DisplayModeToggle: FC<Props> = ({ displayMode, onChange }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'browseCourses.browseCourses' });

    return (
        <div className="flex gap-1">
            {MODES.map(({ mode, icon, labelKey }) => (
                <Tooltip key={mode} content={t(labelKey)}>
                    <Button
                        {...toggleButtonProps(displayMode === mode)}
                        isIconOnly
                        aria-label={t(labelKey)}
                        height={8}
                        onPress={() => onChange(mode)}
                    >
                        <FontAwesomeIcon icon={icon} />
                    </Button>
                </Tooltip>
            ))}
        </div>
    );
};
